import { Component } from '@angular/core';
import { DataService } from '../shared/dataService';
import { BlogEntry } from '../shared/blogEntry';

@Component({
    selector: 'blog-app',
    templateUrl: "./app.component.html",
    styles: []
})
export class AppComponent {
    constructor(private data: DataService) {

    }

    title = 'Blog';

    public blogEntry: BlogEntry = new BlogEntry();
}
